import React from 'react';
import { Helmet } from 'react-helmet';
import { EditCarrier } from 'src/components/EditCarrier';

const EditCarrierPage = () => (
  <>
    <Helmet>
      <title> Edit Carrier</title>
    </Helmet>

    <EditCarrier />
  </>
);

export default EditCarrierPage;
